<template>
    <div>
        <el-row class="headerTop">
            <el-col :span="3">
                <div class="title">
                    {{this.$store.state.title}}
                </div>
            </el-col>
            <el-col :span="2">
                <div class="">
                    <el-button type="primary" @click="handleChangeDialog">增加企业</el-button>
                </div>
            </el-col>
        </el-row>


        <el-dialog title="增加企业" :visible.sync="modalVisible" v-if="modalVisible" width="30%" @close='handleClose' :before-close="handleBeforClose">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                                <el-form-item label="企业名称" prop="qymc" label-width='100px'>
                                    <el-input v-model="ruleForm.qymc" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="承兑总比数" prop="cdzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.cdzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="承兑总金额" prop="cdzje" label-width='100px'>
                                    <el-input v-model="ruleForm.cdzje" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="拒付总笔数" prop="jfzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.jfzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="拒付总金额" prop="jfzje" label-width='100px'>
                                    <el-input  v-model='ruleForm.jfzje' style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="未结清总比数" prop="wjqzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.wjqzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="未结清总金额" prop="wjqzje" label-width='100px'>
                                    <el-input v-model="ruleForm.wjqzje" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm('ruleForm')" class="save">保存</el-button>
                                </el-form-item>
                            </el-form>
        </el-dialog>

                <el-dialog title="修改企业" :visible.sync="changeVisible" v-if="changeVisible" width="30%" @close='handleClose' :before-close="handleBeforClose">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                                <el-form-item label="企业名称" prop="qymc" label-width='100px'>
                                    <el-input v-model="ruleForm.qymc" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="承兑总比数" prop="cdzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.cdzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="承兑总金额" prop="cdzje" label-width='100px'>
                                    <el-input v-model="ruleForm.cdzje" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="拒付总笔数" prop="jfzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.jfzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="拒付总金额" prop="jfzje" label-width='100px'>
                                    <el-input  v-model='ruleForm.jfzje' style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="未结清总比数" prop="wjqzbs" label-width='100px'>
                                    <el-input v-model="ruleForm.wjqzbs" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item label="未结清总金额" prop="wjqzje" label-width='100px'>
                                    <el-input v-model="ruleForm.wjqzje" style="width:300px;"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="submitFormSave('ruleForm')" class="save">保存</el-button>
                                </el-form-item>
                            </el-form>
        </el-dialog>


        <el-row>
            <el-col :span='24'>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                >
                        <el-table-column
                            type="selection"
                            width="55"
                        >
                        </el-table-column>
                        <el-table-column
                            label="序号"
                            prop="serNum"
                            width="95"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="qymc"
                            label="企业名称"
                            width="205"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="cdzbs"
                            label="承兑总笔数"
                            width="165"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="cdzje"
                            label="承兑总金额"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="拒付总笔数"
                            prop="jfzbs"
                            width=""
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="拒付总金额"
                            prop="jfzje"
                            width=""
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="未结清总比数"
                            prop="wjqzbs"
                            width=""
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="未结清总金额"
                            prop="wjqzje"
                            width=""
                        >
                        </el-table-column>

                        <el-table-column
                            fixed="right"
                            label="操作"
                            width=""
                        >
                            <template slot-scope="scope">
                                <el-button
                                @click.native.prevent="changeRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                    修改
                                </el-button>
                                <el-button
                                @click.native.prevent="deleteRow(scope.$index,scope)"
                                type="text"
                                size="small">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            prop="modifyTime"
                            label="最近一次更新时间"
                        >
                        </el-table-column>
                </el-table>
            </el-col>
            <el-col>
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="pagesize"
                        layout="prev, pager, next, jumper"
                        v-show="showPagination"
                        :total=total>
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{
            value:'',
            currentPage:1,
            modalVisible:false,
            changeVisible:false,
            tableData: [],
            showPagination:true,
            total:0,
            pagesize:10,
            ruleForm: {
                qymc: '',
                cdzbs: '',
                cdzje: '',
                jfzbs: '',
                jfzje: '',
                wjqzbs: '',
                wjqzje: '',
            },
            ruleForms: {
                qymc: '',
                cdzbs: '',
                cdzje: '',
                jfzbs: '',
                jfzje: '',
                wjqzbs: '',
                wjqzje: '',
            },
            id:'',
            rules: {
                qymc: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                ]
            }
        }
    },
    mounted(){
        this.handleajax(this.currentPage)
    },
    methods:{
        handleajax(val){
            this.ajax.post('/shangPiao/jfxxList',{bizContent: {currentPage: val,pageSize:this.pagesize}})
                .then(
                    result=>{
                    if(result.data.status=='0000'){
                        let add = result.data.data.data;
                        add.map((it,index)=>{
                            it.serNum=index+1
                        })
                        this.tableData=add
                        this.total=result.data.data.total;
                    }else{
                        this.$message.error(result.message);
                    }
                    }
                )
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm);
                    this.title = this.ruleForm.region;
                    let json = {};
                    json.qymc = this.ruleForm.qymc;
                    json.cdzbs = this.ruleForm.cdzbs;
                    json.cdzje= this.ruleForm.cdzje;
                    json.jfzbs = this.ruleForm.jfzbs;
                    json.jfzje = this.ruleForm.jfzje;
                    json.wjqzbs = this.ruleForm.wjqzbs;
                    json.wjqzje = this.ruleForm.wjqzje
                    let bizContent = json
                    this.ajax.post('/shangPiao/jfxxAdd',{bizContent:bizContent})
                    .then(
                        result=>{
                        if(result.data.status=='0000'){
                                this.$message('企业信息填写成功');
                                this.currentPage=1;
                                this.handleajax(this.currentPage)
                                this.modalVisible=false;
                            }
                        }
                    )
                    // this.visibleShow=false;
                } else {
                    console.log('error submit!!');
                return false;
                }
            });
        },
        submitFormSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.title = this.ruleForm.region;
                    let json = {};
                    json.id = this.id;
                    json.qymc = this.ruleForm.qymc;
                    json.cdzbs = this.ruleForm.cdzbs;
                    json.cdzje= this.ruleForm.cdzje;
                    json.jfzbs = this.ruleForm.jfzbs;
                    json.jfzje = this.ruleForm.jfzje;
                    json.wjqzbs = this.ruleForm.wjqzbs;
                    json.wjqzje = this.ruleForm.wjqzje
                    let bizContent = json
                    this.ajax.post('/shangPiao/jfxxEdit',{bizContent:bizContent})
                    .then(
                        result=>{
                        if(result.data.status=='0000'){
                                this.$message('企业信息填写成功');
                                this.currentPage=1;
                                this.handleajax(this.currentPage)
                                this.changeVisible=false;
                            }
                        }
                    )
                    // this.visibleShow=false;
                } else {
                    console.log('error submit!!');
                return false;
                }
            });
        },
        changeRow(index,val){
            this.id = val.row.id
            this.ajax.post('/shangPiao/jfxxToEdit',{bizContent: {id:val.row.id}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.ruleForm=result.data.data
                        }
                    }
                )
            this.changeVisible= true
        },
        deleteRow(index,val){
            this.ajax.post('/shangPiao/jfxxDel',{bizContent: {id:val.row.id}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            this.currentPage=1
                            this.handleajax(this.currentPage)
                        }
                    }
                )
        },
        handleChangeDialog(){
            this.modalVisible=!this.modalVisible;
        },
        handleClose(){
            this.value =''
            this.currentPage=1
            this.handleajax(this.currentPage)
        },
        handleCurrentChange(val) {
            this.handleajax(val);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleBeforClose(done){
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
                this.ruleForm = this.ruleForms
                this.id=''
            })
            .catch(_ => {});
        }
    }
}
</script>
<style  scoped>
.headerTop{
    margin-top: 10px;
    margin-bottom: 10px;
}
.title{
    color: #333333FF;
    font-size: 24px;
}
.block{
    margin-top: 20px;
    width: 100%;
    text-align: center;
}
.save{
    margin-left: 45%;
}
.el-form-item__content{
    text-align: center!important;
}
</style>


// WEBPACK FOOTER //
// src/page/bussinessticket/refusal.vue